import {DomainEvent} from './DomainEvent';
import {News} from '../resources/News';

export class NewsPublished extends DomainEvent<News> {}
